// fileReducer.js

import {
    SELECT_FILE,
    DESELECT_FILE,
    SET_SELECTED_URLS,
    SELECT_PASSPORT_SIZE_PHOTO,
    SELECT_REG_NUMBER,
    SET_SELECTED_ROWS,
  } from '../actions/fileActions';
  
  const initialState = {
    selectedRows: [],
    selectedURLs: [],
    selectedRegNumber: '',
    selectedPassportSizePhoto: null,
  };
  
  const fileReducer = (state = initialState, action) => {
    switch (action.type) {
      case SELECT_FILE:
        return {
          ...state,
          selectedRows: [...state.selectedRows, action.payload],
        };
      case SELECT_PASSPORT_SIZE_PHOTO:
        return {
          ...state,
          selectedPassportSizePhoto: action.payload,
        };

      case DESELECT_FILE:
        return {
          ...state,
          selectedRows: state.selectedRows.filter((rowId) => rowId !== action.payload),
        };

      case SET_SELECTED_URLS:
        return {
          ...state,
          selectedURLs: action.payload,
        };

      case SET_SELECTED_ROWS:
        return {
          ...state,
          selectedRows: action.payload,
        };
      case SELECT_REG_NUMBER:
        return {
          ...state,
          selectedRegNumber: action.payload,
        };

      default:
        return state;
    }
  };
  
  export default fileReducer;
  